
<div class="form-hgt pad30 marT10" [dir]="textDir">
    <div>
        <div class="head-one header_text"><label class="form-title">{{'Review & complete' | translate}}</label></div>
        <div class="sub_header_text"><label class="label-light">{{projectData.name}}, {{projectData.country.name}}</label></div>
    </div>
    <div class="h-line marT20"></div>
    <div class="scroll-thin padT10">
    <div class="pre-white ">
   
    <div class="flexStart marT10">
        <div class="sm-1"><label class="label-light">{{'Grades' | translate}}</label> </div>
        <div class="flexStart wid-90">
        <div class="marT5 list-pos">         
            
            <ul class="g-list" *ngFor="let grade of gradeData| orderBy:['year.number']; let i = index">
                <li class="labeltxt flexStart"><div class="sm-3">{{grade?.name}}</div>  <div class="sm-6 opac-6">{{grade?.year?.name}}</div></li>
            </ul>
           </div>
      
    </div>
    </div>
</div>
<div class="h-line marT15"></div>
<div class="pre-white ">

    <div class="flexStart marT10">
        <div class="sm-1"><label class="label-light">{{'Subjects' | translate}}</label> </div>
        <div class="flexStart wid-90">
        <div class="marT5 list-pos">         
            
            <ul class="g-list" *ngFor="let subject of subjectData; let i = index">
                <li class="labeltxt flexStart"><div class="sm-4">{{subjectData[i]?.name|ucfirst}}</div> </li>
            </ul>
           </div>
      
    </div>
    </div>
    
  <!--   <div class="flexStart row">
        <div class="labl-wid"><label class="label-light">Subjects</label> </div>

        <div class="marT5 list-pos">

            <ul class="g-list" *ngFor="let subject of subjectData;let i = index">
                <li class="labeltxt">{{subjectData[i]?.name|ucfirst}}</li>
            </ul>
           
        </div>
       
        
    </div> -->
</div>
</div>
</div>